// extracted by mini-css-extract-plugin
export default {"login":"LoginPage_login__1M0C9","container":"LoginPage_container__tYl7J","login__title":"LoginPage_login__title__+UfHS"};